export const replaceHostToCurrent = (href: string) => {
  try {
    const url = new URL(href);
    if (["www.snapptrip.com", "pwa.snapptrip.com"].includes(url.hostname))
      url.hostname = window.location.host;
    return url;
  } catch {
    return href;
  }
};
